class ProductModal {
  constructor() {
    this.modal = document.getElementById('product-tearsheet-modal');
    this.overlay = this.modal.querySelector('.product-tearsheet-modal__overlay');
    this.container = this.modal.querySelector('.product-tearsheet-modal__container');
    this.content = this.modal.querySelector('.product-tearsheet-modal__content');
    this.openButton = document.querySelector('.main-product__modal-button[data-modal-open]');
    this.closeButtons = document.querySelectorAll('[data-modal-close]');
    this.printButton = document.getElementById('print-details');
    this.printFitApplied = false;

    this.init();
  }
  
  init() {
    // Open modal
    if (this.openButton) {
      this.openButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    }
    
    // Close modal
    this.closeButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.close();
      });
    });
    
    // Print functionality
    if (this.printButton) {
      this.printButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.preparePrintFit();
        window.print();
      });
    }

    window.addEventListener('beforeprint', () => this.preparePrintFit());
    window.addEventListener('afterprint', () => this.resetPrintFit());
    
    // Close on overlay click
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.close();
      }
    });
    
    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });
  }
  
  open() {
    this.modal.style.display = 'block';
  }
  
  close() {
    this.modal.style.display = 'none';
  }

  preparePrintFit() {
    if (this.printFitApplied || !this.content) return;

    this.clearPrintFitStyles();
    this.modal.classList.add('product-tearsheet-modal--fitting');
    this.content.offsetHeight;

    // US Letter printable area (matches --tearsheet-page-width; 11in - margins).
    const maxWidth = 7.5 * 96;
    const maxHeight = 9.6 * 96;
    const height = this.content.scrollHeight;
    const width = this.content.scrollWidth;

    if (!height || !width) {
      this.printFitApplied = true;
      return;
    }

    const scale = Math.min(1, maxHeight / height, maxWidth / width);

    if (Number.isFinite(scale) && scale > 0 && scale < 0.999) {
      if (typeof CSS !== 'undefined' && CSS.supports('zoom', '0.5')) {
        this.content.style.zoom = String(scale);
      } else {
        this.content.style.transformOrigin = 'top center';
        this.content.style.transform = `scale(${scale})`;
        this.content.style.marginBottom = `${-height * (1 - scale)}px`;
      }
    }

    this.printFitApplied = true;
  }

  clearPrintFitStyles() {
    if (!this.content) return;

    this.content.style.zoom = '';
    this.content.style.transform = '';
    this.content.style.transformOrigin = '';
    this.content.style.marginBottom = '';
  }

  resetPrintFit() {
    this.printFitApplied = false;
    this.modal.classList.remove('product-tearsheet-modal--fitting');
    this.clearPrintFitStyles();
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductModal();
}); 